# Integrations

Anonymator integrates seamlessly with any REST API — but we also provide **direct integrations** with popular automation platforms.

---

## Available Integrations

- [n8n](/integrations/n8n/n8n-anonymize) – Automate anonymization and deanonymization with Anonymator’s REST API directly inside n8n.  
- [Make.com](/integrations/make/make-anonymize) – Connect Anonymator with Make.com to anonymize text through automated HTTP requests and visual workflows.  
- [Pabbly Connect](/integrations/pabbly/pabbly-anonymize) – Integrate Anonymator into Pabbly Connect to automatically anonymize text within your automation scenarios.


---

You can explore each integration’s guide in the menu on the left for setup instructions and examples.
